<template>

<div class="topAD">
<div class="topADText">今日新区名额有限领取豪礼</div>
<a  class="topADQQ" :href="qqlink">加入QQ群聊</a>
</div>

  <div id="app">
    <div><img :src="myImage" class="responsive-image" /></div>
    <div><img :src="myImage1" class="responsive-image" /></div>
    <div><img :src="myImage2" class="responsive-image" /></div>
    <p style="padding:8px;font-size:12px;">广州游戏有限公司</p>
    <br /><br /><br /><br />
  </div>

<a class="mybutton" :href="qqlink">点击加入QQ群</a>

</template>

<script>
import myImage from './assets/1.gif';  // 通过 import 引入图片
import myImage1 from './assets/2.gif';  // 通过 import 引入图片
import myImage2 from './assets/3.gif';  // 通过 import 引入图片
import qq from './assets/qq.webp';  // 通过 import 引入图片
let  qqlink='https://qm.qq.com/cgi-bin/qm/qr?k=QeUuBX8zi30ttFq42OoBkcU_X9HHZ_ez&jump_from=webapi&authKey=bDwsEApYUO40JHlx9JGIIGe1iqQs3OYaF/V0eqQCBaP3wlsbcDMNgacj586xPRfA';
export default {
  name: 'App',
  data() {
    return {
      myImage,
      myImage1,
      myImage2,
      qq,
      qqlink
    };
  },
  components: {}
}
</script>

<style scoped>

 a{ text-decoration: none; } 

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding:0px;
}

.topAD{
  display:flex;
    height: 3.2rem;
  line-height:3.2rem;
  position:fixed;
  background:#fff;
  width:100%;
  top:0px;
  max-width:800px;
}

.topAD .topADText{
width:70%;
padding-left:8px;
}

.topAD .topADQQ{
  flex:1;
  background-color: rgb(248, 231, 28);
  color: rgb(243, 53, 49);
  box-sizing: border-box;
  text-align:center;
}



.responsive-image {
  max-width: 100%;
  height: auto;
  /* 确保图片根据屏幕宽度自适应 */
  display: block;
  margin: 0 auto;
  
}

.mybutton{
  background-color: rgb(248, 231, 28);
  color: rgb(243, 53, 49);
  border: medium;
  border-radius: 9px;
  box-sizing: border-box;
  width:98%;
  height: 3.2rem;
  line-height: 3.2rem;
  box-shadow: rgb(161, 149, 0) 0px 0.0625rem 0.375rem 0px;
  position: fixed;    /* 设置为fixed，固定在视口中 */
  bottom: 8px;       /* 距离底部20px */
  left: 50%;          /* 水平居中 */
  transform: translateX(-50%); /* 通过transform将按钮居中 */
  z-index: 1000;      /* 确保按钮在页面顶部 */
  font-size:1.25rem;
  font-weight:bold;
  display:block;
  text-align:center;
  max-width:800px
}

/* 媒体查询: 针对不同屏幕尺寸调整图片和容器 */
@media (max-width: 768px) {
  #app {
    margin-top: 0px;
    padding: 0 0px;
    margin:0px;
  }
  .responsive-image {
    max-width: 90%;  /* 确保图片在小屏幕下不会超出 */
  }
}

@media (max-width: 480px) {
  .responsive-image {
    max-width: 100%;  /* 在非常小的屏幕上，图片占满宽度 */
  }
}
</style>
